import React from 'react';
import { CheckCircle2, Clock, Package, Truck, MapPin, RotateCcw } from 'lucide-react';

const PIPELINE = [
  { key: 'paid',          label: 'Confirmed',     icon: CheckCircle2 },
  { key: 'in_production', label: 'In Production',  icon: Package },
  { key: 'packed',        label: 'Packed',         icon: Package },
  { key: 'dispatched',    label: 'Shipped',        icon: Truck },
  { key: 'delivered',     label: 'Delivered',      icon: MapPin },
];

const REFUND_STATUSES = ['refunded', 'partially_refunded'];

export default function OrderTimeline({ status }) {
  if (status === 'pending' || status === 'failed') return null;
  if (REFUND_STATUSES.includes(status)) {
    return (
      <div className="flex items-center gap-2 py-3">
        <RotateCcw className="w-4 h-4 text-orange-400" />
        <span className="text-orange-400 text-xs font-bold tracking-wider">
          {status === 'refunded' ? 'FULLY REFUNDED' : 'PARTIALLY REFUNDED'}
        </span>
      </div>
    );
  }

  // 'completed' is a terminal state — show the whole pipeline as done.
  const progressStatus = status === 'completed' ? 'delivered' : status;
  const currentIdx = PIPELINE.findLastIndex(p => {
    if (progressStatus === p.key) return true;
    // treat later statuses as also completing earlier ones
    const statusOrder = ['paid', 'in_production', 'packed', 'dispatched', 'delivered'];
    return statusOrder.indexOf(progressStatus) > statusOrder.indexOf(p.key);
  });

  return (
    <div className="pt-4">
      <p className="text-white/30 text-[10px] font-bold tracking-widest mb-4">ORDER PROGRESS</p>
      <div className="flex items-start">
        {PIPELINE.map((step, i) => {
          const StepIcon = step.icon;
          const done = i <= currentIdx;
          const active = i === currentIdx;
          return (
            <React.Fragment key={step.key}>
              <div className="flex flex-col items-center gap-1.5 min-w-0 flex-shrink-0">
                <div className={`w-7 h-7 flex items-center justify-center rounded-full border-2 transition-all ${
                  active ? 'border-primary bg-primary/30 shadow-[0_0_10px_rgba(192,57,43,0.4)]'
                  : done ? 'border-primary/60 bg-primary/15'
                  : 'border-white/10 bg-transparent'
                }`}>
                  <StepIcon className={`w-3.5 h-3.5 transition-colors ${
                    done ? 'text-primary' : 'text-white/20'
                  }`} />
                </div>
                <span className={`text-[9px] font-bold tracking-wider text-center leading-tight px-1 ${
                  active ? 'text-primary' : done ? 'text-white/40' : 'text-white/15'
                }`}>
                  {step.label}
                </span>
              </div>
              {i < PIPELINE.length - 1 && (
                <div className={`h-[2px] flex-1 mx-1 mt-3.5 transition-colors ${
                  i < currentIdx ? 'bg-primary/40' : 'bg-white/5'
                }`} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}